// extracted by mini-css-extract-plugin
module.exports = {"profileStyleWrapper":"Profile_profileStyleWrapper__TynSO"};